import { UserSettingsEmail } from 'feature/user/view'
import { MainLayout } from 'layouts'

export function UserSettingsEmailPage() {
  return (
    <MainLayout>
      <div className='container'>
        <UserSettingsEmail />
      </div>
    </MainLayout>
  )
}
